import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './HeroSection.css';
import { getApiUrl } from '../../config/api';
import iconPlayers from '../../assets/feather-icon.svg';
import iconConnect from '../../assets/lucide-icon.svg';

const HeroSection = () => {

    const [playerCount, setPlayerCount] = useState('...');
    const maxPlayers = 64;

    useEffect(() => {
        const fetchPlayerCount = async () => {
            try {
                const response = await fetch(getApiUrl('/get_player_count'));
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();

                // Si el servidor FiveM está en mantenimiento, mostrar mensaje especial
                if (data.fivem_maintenance === true) {
                    setPlayerCount('Servidor en Desarrollo');
                } else if (data.status === 'success' && typeof data.players === 'number') {
                    setPlayerCount(data.players);
                } else {
                    setPlayerCount('Error al conectar');
                }
            } catch (error) {
                console.log('Error fetching player count:', error);
                setPlayerCount('Error al conectar');
            }
        };

        fetchPlayerCount();
        // Actualiza cada 30 segundos
        const intervalId = setInterval(fetchPlayerCount, 30000);
        return () => clearInterval(intervalId);
    }, []);

    return (
        <section className="hero-section-overlap no-scroll">
            <div className="hero-content-columns">
                <div className="hero-left-column" data-aos="fade-right" data-aos-delay="200">
                    <img src="/logo512.png" alt="Logo Principal del Rol" className="hero-main-logo" />
                    <p className="hero-intro-text">
                        ¡Bienvenido a nuestro servidor de rol. Sumérgete en un mundo de posibilidades, crea tu historia y vive aventuras inolvidables con nuestra comunidad!
                    </p>
                    <Link
                        to="/mas-informacion"
                        className="hero-more-info-btn"
                    >
                        Más Información
                    </Link>


                </div>
                <div className="hero-right-content-wrapper" data-aos="fade-left" data-aos-delay="400">
                    <div className="hero-main-post">
                        <h1 className="hero-title" data-aos="fade-up" data-aos-delay="600">
                            ¡ÚNETE A NUESTRA COMUNIDAD!
                        </h1>
                        <p className="hero-description" data-aos="fade-up" data-aos-delay="700">
                            Explora el mapa, experimenta nuestro entorno único y sumérgete en una experiencia de juego inigualable.
                        </p>
                    </div>
                    <div className="hero-info-boxes-container">
                        <div className="hero-info-box" data-aos="fade-up" data-aos-delay="800">
                            <img src={iconPlayers} alt="Players Icon" className="hero-icon" />
                            <span
                                className="hero-players-count"
                                data-maintenance={playerCount === 'Servidor en Mantenimiento' ? 'true' : 'false'}
                                data-error={playerCount === 'Error al conectar' ? 'true' : 'false'}
                            >
                                {playerCount === 'Servidor en Mantenimiento' ? 'Servidor en Mantenimiento' :
                                    playerCount === 'Error al conectar' ? 'Error al conectar' :
                                        typeof playerCount === 'number' ? `${playerCount}/${maxPlayers} En línea` :
                                            playerCount}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;